
<template>
    
        <mars-view><mars-view :id="contentId" class="im-input-wrapper"><mars-view class="sug-box"><mars-view v-for="(item, index) in sugList" :key="index" class="sug-item l-font-medium" @click.native="selectSugItem(item)"><mars-rich-text :nodes="item.text"></mars-rich-text></mars-view></mars-view><mars-view v-if="floatBtns && floatBtns.list && floatBtns.list.length > 0" class="speed-call-lawyer" :class="(showSpeedCall && pageShowStatus) ? 'speed-call-lawyer-light' : ''" :style="{top: showServiceCard && recommendServices && recommendServices.length > 0 ? '-188px' : '-80px'}" @click.native.stop="showSpeedCalls(true)"><mars-view class="speed-content"><mars-view class="top">{{ floatBtns.list[0].title }}</mars-view><mars-view class="bottom">{{ floatBtns.list[0].sub }}</mars-view></mars-view><mars-view class="space-close" @click.native.stop="showSpeedCalls(false)"><mars-view class="icon iconfont close-speed"></mars-view></mars-view></mars-view><mars-view v-if="recommendServices && recommendServices.length > 0 && showServiceCard" class="doc-service-card"><mars-view class="doc-service-content"><mars-image :lazy-load="true" class="doc-service-content-image" :src="recommendServices[0].service_img"></mars-image><mars-view class="doc-service-content-info"><mars-view class="content-info-name">{{ recommendServices[0].service_name }}</mars-view><mars-view class="content-info-price-group"><mars-view><mars-text class="content-info-price">¥{{ recommendServices[0].display_price }}</mars-text><mars-text class="content-info-ori-price">¥{{ recommendServices[0].display_ori_price }}</mars-text></mars-view><mars-view class="doc-service-content-button"><mars-view class="content-butt" @click.native="sendServiceCard">
                                发送链接
                            </mars-view></mars-view></mars-view><mars-view class="icon iconfont close" @click.native="closeServiceCard"></mars-view></mars-view></mars-view></mars-view><mars-view v-if="serviceBtns.length" class="im-input-product-content"><mars-view class="im-input-product-list"><mars-view v-for="item in serviceBtns" :key="item.service_id" class="im-input-product-item" @click.native="sendProduct(item)">
                    {{ item.service_name }} ￥{{ item.display_price }}
                </mars-view></mars-view></mars-view><mars-view class="im-input-main"><template><mars-view class="im-input-textarea-wrapper-h5"><mars-textarea :id="textareaId" v-model="textValue" class="im-input-control-textarea-h5" :disabled="disabled" :maxlength="maxlength" :placeholder="placeholder" @input="onInput" @blur="h5TextareaBlur"></mars-textarea><div class="inner-ph">
                        {{ sugQuery || textValue || placeholder }}
                    </div><mars-view v-if="(showInputClear || showInputClearBtn) && textValue" class="clear-input icon iconfont" @click.native="clearTextValue"></mars-view></mars-view></template><mars-view class="input-send" :class="!isForbid && (textValue.length >= textValueNumber || (pageFrom === 'chat' && textValue)) ? 'input-send-enable' : 'input-send-disable'" :style="{width: textFocus ? '66px' : '65px'}" @click.native="sendText">
                发送
                <mars-form v-if="isSwan && (textValue.length >= textValueNumber || (pageFrom === 'chat' && textValue))" class="subscribe-form" :report-submit="true" report-type="subscribe" template-id="BD1541" subscribe-id="2ead8c4a07ca42a297dc9853e60b447d" @submit="formSubmit" @reset="formReset"><mars-button formType="submit" class="subscribe-button" type="primary" @click.native.stop></mars-button></mars-form></mars-view></mars-view><mars-view v-if="recording" class="im-input-recording"><mars-image v-if="talking" class="im-input-recording-gif" src="https://law-smartapp.cdn.bcebos.com/gif/talk.gif"></mars-image><mars-text v-else class="im-input-recording-text">按住说话</mars-text><mars-image class="im-input-recording-image" image-menu-prevent :src="'https://law-smartapp.cdn.bcebos.com/' + (talking ? 'icon-talk-dark' : 'chat/icon-talk') + '.png'" @touchstart.native.stop="voiceRecognizerStart" @touchend.native.stop="voiceRecognizerEnd" @touchcancel.native.stop="voiceRecognizerCancel"></mars-image></mars-view><mars-view v-if="scrollHeight > 0" class="c-triage-scroll" :style="{height: scrollHeight + 'px'}"></mars-view><mars-view v-if="extraList && extraList.length > 0" class="input-extra-content" :style="{height: showExtra ? extraHeight + 'px' : '0'}"><mars-view class="swiper-item"><mars-view v-for="item in extraList" :key="item.txt" class="input-extra-list-item" @click.native="clickExtraItem(item)"><mars-view class="input-extra-list-item-inner"><mars-view class="input-extra-list-image"><mars-image class="image" :src="item.image"></mars-image></mars-view><mars-view class="input-extra-list-txt">
                            {{ item.txt }}
                        </mars-view></mars-view></mars-view></mars-view></mars-view></mars-view></mars-view>
    
</template>

<script>
// import {sendLog} from '../../common/js/log.js';
/* globals swan */
// 二十大临时注释
// import upload from '../../components/common/upload';
import { productList } from '../../pages/chat/product';
import { reqPathTo } from '../../static/utils/env.js';
export default {
  // 二十大临时注释
  // components: {
  //     'c-upload': upload
  // },
  props: {
    /**
     * 是否显示右侧电话浮窗
     */
    pageShowStatus: {
      type: Boolean,
      default: true
    },
    /**
     * 输入框是否可输入
     */
    disabled: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: Number,
      default: 300
    },
    placeholder: {
      type: String,
      default: '请输入'
    },
    pageFrom: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    caretColor: {
      type: String,
      default: '#000'
    },
    extraStatus: {
      type: Boolean,
      default: false
    },
    extraList: {
      type: Array,
      default: function () {
        return [];
      }
    },
    recording: {
      type: Boolean,
      default: false
    },
    showProduct: {
      type: Boolean,
      default: true
    },
    serviceBtns: {
      type: Array,
      default: function () {
        return [];
      }
    },
    recommendServices: {
      // 底部卡片数据
      type: Array,
      default: function () {
        return [];
      }
    },
    floatBtns: {
      // 右侧浮窗数据
      type: Object,
      default: function () {
        return {};
      }
    },
    textValueNumber: {
      // 字数限制个数
      type: Number,
      default: 5
    },
    showInputClearBtn: {
      type: Boolean,
      default: false
    },
    querySug: {
      type: Number,
      default: 0
    },
    isAndroid: {
      type: Boolean,
      default: false
    },
    isForbid: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      textValue: '',
      recordingValue: '',
      textFocus: false,
      isAutoHeight: true,
      iconUrl: 'https://expertimg.bj.bcebos.com/expertimg/b1559285477619898507.png',
      showExtra: this.extraStatus,
      showControls: false,
      contentHeight: -1,
      textareaId: 'textarea-id-',
      contentId: 'content-id-',
      h5InputId: 'h5-input-id-',
      focusStatus: false,
      extraHeight: '',
      isSwan: "h5" === 'swan',
      talking: false,
      productList,
      showSpeedCall: false,
      showServiceCard: true,
      showInputClear: false,
      sugList: [],
      scrollHeight: 0,
      formId: '',
      sugQuery: ''
    };
  },
  watch: {
    value(val) {
      this.textValue = val;
    },
    extraStatus(val) {
      this.showExtra = val;
      this.changeHeight();
    },
    extraList(val) {
      if (val.length) {
        this.extraHeight = val.length > 4 ? 228 : 125;
      }
    }
  },
  mounted() {
    this.textareaId = this.textareaId + Math.floor(Math.random() * 10000);
    this.contentId = this.contentId + Math.floor(Math.random() * 10000);
    this.h5InputId = this.h5InputId + Math.floor(Math.random() * 10000);
    // 避免手动获取节点高度
    if (this.extraList.length) {
      this.extraHeight = this.extraList.length > 4 ? 228 : 125;
    }
    this.$emit('updateImListPaddingBootom', this.serviceBtns.length ? 108 : 54);
    this.sugQuery = this.value;
    this.$mpUpdated(() => {
      this.textValue = this.value;
    });
  },
  methods: {
    formSubmit(e) {
      this.formId = e.detail.formId || '';
      this.sendText();
    },
    /**
     * 选择sug提示语句
     * @return {void}
     */
    selectSugItem(item) {
      this.showInputClear = true;
      this.sugQuery = item.query;
      this.sugList = [];
      this.$mpUpdated(() => {
        this.textValue = item.query;
      });
    },
    /**
     * 清除input内容
     * @return {void}
     */
    clearTextValue() {
      this.textValue = '';
      this.sugQuery = '';
      this.sugList = [];
    },
    /**
     * 咨询引导页面发送商品卡片链接
     * @param {loginStatus} Boolean 当前是否已知登录成功
     * @return {void}
     */
    sendServiceCard() {
      this.$emit('sendServiceCard', {
        text: '',
        loginStatus: false,
        isPushMsg: true
      });
      this.showServiceCard = false;
    },
    /**
     * 咨询引导页面关闭商品卡片显示
     * @return {void}
     */
    closeServiceCard() {
      this.showServiceCard = false;
    },
    /**
     * 咨询引导页面改变右侧浮窗显隐状态
     * @param {status} Boolean 点击之后浮窗显隐状态
     * @return {void}
     */
    showSpeedCalls(status) {
      this.showSpeedCall = status;
      this.$emit('changeShowSpeedCall', status);
    },
    voiceRecognizerStart() {
      // AI系列的api有宿主使用限制,只可在百度App中使用,建议使用时加一层判断防止代码报未知错误
      let host = swan.getSystemInfoSync().host;
      if (host === 'baiduboxapp') {
        this.voiceRecognizer = swan.ai.getVoiceRecognizer();
        this.voiceRecognizer.onFinish(res => {
          this.textValue = this.textValue + res.result;
          this.recordingValue = '';
        });
        this.voiceRecognizer.onRecognize(res => {
          this.recordingValue = this.textValue + res.result;
        });
        this.voiceRecognizer.start({
          mode: 'touch',
          longSpeech: false
        });
        this.voiceRecognizer.onError(res => {
          if (res.errorCode === '10003') {
            swan.showModal({
              title: '授权失败',
              content: '请前往小程序设置打开麦克风权限'
            });
          }
        });
        this.talking = true;
      } else {
        swan.showToast({
          title: '此api目前仅可在百度App上使用',
          icon: 'none'
        });
      }
    },
    voiceRecognizerEnd() {
      let host = swan.getSystemInfoSync().host;
      if (host === 'baiduboxapp') {
        this.voiceRecognizer.stop();
        this.talking = false;
      } else {
        swan.showToast({
          title: '此api目前仅可在百度App上使用',
          icon: 'none'
        });
      }
    },
    voiceRecognizerCancel() {
      let host = swan.getSystemInfoSync().host;
      if (host === 'baiduboxapp') {
        this.voiceRecognizer.cancel();
        this.talking = false;
      } else {
        swan.showToast({
          title: '此api目前仅可在百度App上使用',
          icon: 'none'
        });
      }
    },
    clickExtraIcon() {
      // 点击+触发事件
      this.$emit('updateExtraStatus', !this.showExtra);
    },
    onFocus(event) {
      this.textFocus = true;
      this.closeServiceCard();
      this.$emit('focus', event);
      if (this.showExtra) {
        this.$emit('updateExtraStatus', false);
      }
      this.showControls = true;
      this.activeControls();
      this.scrollHeight = event && event.detail && event.detail.height; // 获取键盘高度并保存
      this.$emit('updateRecording', false);
    },
    onBlur() {
      this.textFocus = false;
      this.scrollHeight = 0; // 清除键盘高度，使得输入框恢复原来位置
      this.$emit('blur');
    },
    h5TextareaBlur() {
      setTimeout(function () {
        window.scrollTo({
          top: 5000,
          left: 0,
          behavior: 'smooth'
        }); // 当键盘收起的时候让页面回到原始位置
      }, 200);
    },
    onInput(e) {
      this.textValue = e.detail.value;
      this.sugQuery = '';
      if (e.detail.value && this.pageFrom === 'imchat' && this.querySug) {
        // 输入框有内容变化请求sug提示接口
        this.getSugList(e.detail.value);
      } else {
        setTimeout(() => {
          if (!this.sugQuery && !this.recordingValue && !this.textValue) {
            this.sugList = [];
          }
        }, 300);
      }
    },
    // 下拉框推荐数据
    getSugList(query) {
      const sugUrl = reqPathTo('regulation/sug', {}, '', 'law');
      return this.$api.request({
        url: sugUrl,
        data: {
          sug_source: 'qa',
          query
        }
      }).then(res => {
        try {
          let {
            sug_list
          } = res.data.data;
          if (Array.isArray(sug_list)) {
            sug_list = sug_list.map(item => {
              let obj = {
                query: item,
                text: item.replace(new RegExp(query, 'g'), `<span class="query-normal">${query}</span>`)
              };
              return obj;
            });
            if (this.sugQuery || this.recordingValue || this.textValue) {
              this.sugList = sug_list.slice(0, 3);
            } else {
              this.sugList = [];
            }
          }
        } catch (e) {}
      });
    },
    // 监听输入行发生变化
    onLinechange(e) {
      this.isAutoHeight = !(e.detail.lineCount >= 3);
      if (e.detail.lineCount <= 3) {
        const bottomHeight = this.serviceBtns.length ? 112 : 58;
        let imListPaddingBootom = bottomHeight + (e.detail.lineCount - 1) * 20;
        this.$emit('updateImListPaddingBootom', imListPaddingBootom);
      }
    },
    closeExtra() {
      this.$emit('updateExtraStatus', false);
    },
    stopUp(e) {
      e.stopPropagation();
    },
    changeHeight() {
      this.contentHeight = this.showExtra ? this.extraHeight + 54 : 54;
    },
    forbiddenScroll(e) {
      e.preventDefault();
    },
    activeControls() {
      if (!this.disabled) {
        this.showControls = true;
        this.$nextTick(() => {
          let realInput = document.querySelector('#' + this.textareaId);
          if (realInput) {
            realInput.focus();
          }
          this.$api.createSelectorQuery().select('#' + this.h5InputId).boundingClientRect(rect => {
            this.contentHeight = rect && rect.height;
          }).exec();
        });
      }
    },
    deactiveControls(isInit) {
      this.showControls = false;
      if (isInit) {
        // trick 解决高度不下降
        this.contentHeight = 50;
      } else {
        this.changeHeight();
      }
    },
    clickExtraItem(item) {
      this.$emit('clickExtraItem', item);
    },
    sendText() {
      if (this.isForbid) {
        return;
      }
      if (this.textValue.trim() !== '') {
        this.focusStatus = true;
        this.$emit('sendText', this.textValue, this.formId);
        // trick 解决回调函数textValue无法置空
        this.textValue = '';
        this.isAutoHeight = true;
        this.$mpUpdated().then(() => {
          this.textValue = '';
          this.deactiveControls(true);
        });
      }
    },
    sendProduct(item) {
      this.$emit('tapSendProduct', item);
    },
    handleRecording() {
      if (!this.disabled) {
        this.$emit('updateRecording', !this.recording);
      }
    },
    changeImage(list) {
      let img_list = [];
      list.forEach(item => {
        img_list.push({
          img: item.url,
          width: item.w,
          height: item.h
        });
      });
      this.$emit('sendImageList', {
        img_list
      });
    }
  }
};
</script>

<style scoped>
textarea {
  outline: none;
  resize: none;
}
.shadow {
  height: 52px;
  transition: height 0.3s;
}
.im-input-wrapper {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  background-color: #fff;
}
.sug-box {
  width: 100%;
  background: #fff;
  position: absolute;
  left: 0;
  bottom: 100%;
  padding: 0 0.17rem;
  border-bottom: 0.33px solid #e0e0e0;
  box-sizing: border-box;
}
.sug-box .sug-item {
  font-size: 0.16rem;
  color: #1f1f1f;
  line-height: 0.42rem;
  font-weight: 500;
  border-bottom: 0.33px solid #e0e0e0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 700;
}
.sug-box .sug-item:last-child {
  border: none;
}
.sug-box .query-normal,
.sug-box /deep/ span {
  color: #1f1f1f;
  font-weight: 400;
  font-family: PingFangSC-Regular;
  text-decoration: none;
  font-style: normal;
}
.sug-box [class*="query-normal"] {
  color: #1f1f1f;
  font-weight: 400;
  font-family: PingFangSC-Regular;
  text-decoration: none;
  font-style: normal;
}
.im-input-tag-box {
  max-width: 100%;
  overflow: scroll;
}
.im-input-tag-box::-webkit-scrollbar {
  display: none;
}
.im-input-tag {
  width: 100%;
  background: #fff;
  box-shadow: 0 13px 13px 0 rgba(0, 0, 0, 0.02);
  padding: 12px 17px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  overflow: scroll;
}
.im-input-tag-item {
  padding: 8px 12px;
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 14px;
  color: #1f1f1f;
  text-align: center;
  line-height: 14px;
  font-weight: 400;
  border: 1px solid #ccc;
  border-radius: 15px;
  box-sizing: border-box;
  margin-right: 5px;
}
.im-input-main {
  background-color: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 7px 17px;
}
.im-input-recording {
  width: 100%;
  height: 200px;
  padding-top: 34px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.im-input-recording-gif {
  width: 90px;
  height: 17px;
  display: inline-block;
  margin: 4px auto 3px;
}
.im-input-recording-text {
  width: 100%;
  height: 24px;
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 16px;
  color: #ccc;
  letter-spacing: 0;
  text-align: center;
  line-height: 24px;
  font-weight: 400;
  display: flex;
  justify-content: center;
  align-items: center;
}
.im-input-recording-image {
  width: 80px;
  height: 80px;
  margin-top: 20px;
}
.im-input-icon {
  font-size: 24px;
  margin-right: 17px;
}
.im-input-icon [class*='__consult-form-content-img'] {
  font-size: 24px;
}
.im-input-textarea-wrapper {
  flex: 1;
  align-items: center;
  background: #f5f5f5;
  border-radius: 19px;
  overflow: hidden;
  position: relative;
  padding: 10px 0 10px;
}
.im-input-textarea-wrapper .clear-input {
  width: 0.16rem;
  height: 0.16rem;
  position: absolute;
  right: 0.1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #b8b8b8;
  font-size: 0.16rem;
  line-height: 0.16rem;
  padding: 0.05rem;
  z-index: 20;
}
.im-input-textarea {
  font-size: 16px;
  width: calc(100% - 45px);
  height: calc(100% - 20px);
  max-height: 57px;
  box-sizing: border-box;
  background-color: #f5f5f5;
  color: #222;
  word-break: break-word;
  word-wrap: break-word;
  border: none;
  display: block;
  position: absolute;
  line-height: 16px;
  margin: 0 20px 0 15px;
  overflow: scroll;
}
.input-extra-icon {
  font-size: 20px;
  line-height: 1;
  color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-left: 13px;
}
.input-extra-content {
  background-color: #f2f2f2;
  /* transition: height .3s; */
}
.swiper-item-wrapper {
  height: 138px;
}
.swiper-item {
  padding: 22px 17px 0 17px;
  display: flex;
  flex-direction: row;
  justify-content: left;
  flex-wrap: wrap;
}
.input-extra-list-item {
  width: 25%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 16px;
}
.input-extra-list-item-inner {
  text-align: center;
}
.input-extra-list-image {
  background-color: #fff;
  width: 58px;
  height: 58px;
  border-radius: 10px;
}
.input-extra-list-txt {
  font-size: 13px;
  line-height: 29px;
  color: #666;
}
.input-send {
  margin: 0 0 0 17px;
  font-size: 16px;
  font-weight: 700;
  min-width: 34px;
  height: 38px;
  line-height: 38px;
  position: relative;
}
.input-send .subscribe-form {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.input-send .subscribe-form .subscribe-button {
  width: 100%;
  height: 100%;
  opacity: 0;
}
.input-send-disable {
  color: #fff;
  width: 70px;
  height: 38px;
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 16px;
  text-align: center;
  line-height: 38px;
  background: #dadff1;
  border-radius: 19px;
}
.input-send-enable {
  color: #fff;
  width: 70px;
  height: 38px;
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 16px;
  text-align: center;
  line-height: 38px;
  border-radius: 19px;
  background: #445fbb;
}
.image {
  margin: 15px 16px;
  width: 26px;
  height: 28px;
}
.im-input-icon-disabled {
  color: #f5f5f5;
}
.im-input-icon-disabled [class*='__consult-form-content-img'] {
  color: #f5f5f5;
}
.im-input-product-content {
  width: 100%;
  height: 53px;
  overflow-x: auto;
  overflow-y: hidden;
}
.im-input-product-list {
  width: fit-content;
  height: 53px;
  padding: 0 12px 0 17px;
  line-height: 53px;
  white-space: nowrap;
}
.im-input-product-content::-webkit-scrollbar {
  /* background-color:transparent; */
  display: none;
}
.im-input-product-item {
  display: inline-block;
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 14px;
  color: #1f1f1f;
  line-height: 14px;
  padding: 7px 12.5px;
  border: 1px solid #ccc;
  border-radius: 45px;
  margin-right: 5px;
  box-sizing: border-box;
}
.doc-service-card {
  width: calc(100% - 34px);
  border-radius: 8px;
  overflow: hidden;
  margin-left: 17px;
  margin-bottom: 20px;
  background: #fff;
  position: absolute;
  left: 0;
  top: -116px;
}
.doc-service-content {
  padding: 15px 13px;
  display: flex;
  justify-content: space-between;
}
.doc-service-content-image {
  width: 66px;
  height: 66px;
  flex-grow: 0;
  flex-shrink: 0;
}
.doc-service-content-info {
  width: 66px;
  min-height: 66px;
  flex: 1;
  margin-left: 13px;
  position: relative;
}
.doc-service-content-info .content-info-name {
  height: 16px;
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 16px;
  color: #222;
  line-height: 16px;
  font-weight: 500;
  margin-bottom: 22px;
}
.doc-service-content-info .content-info-price-group {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: -10px;
}
.doc-service-content-info .content-info-price {
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 19px;
  line-height: 19px;
  color: #ff514c;
  font-weight: 500;
}
.doc-service-content-info .content-info-ori-price {
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 12px;
  color: #999;
  letter-spacing: 0;
  line-height: 12px;
  font-weight: 400;
  margin-left: 4px;
  text-decoration: line-through;
  margin-bottom: 2px;
}
.doc-service-content-info .close {
  font-size: 20px;
  position: absolute;
  right: 0;
  top: -4px;
  color: #999;
}
.doc-service-content-button {
  align-self: flex-end;
  flex-grow: 0;
  flex-shrink: 0;
  margin-top: 10px;
}
.doc-service-content-button .content-butt {
  width: 78px;
  height: 28px;
  background: #445fbb;
  border-radius: 17px;
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 12px;
  color: #fff;
  text-align: center;
  line-height: 28px;
  font-weight: 500;
  position: relative;
}
.speed-call-lawyer {
  width: 197px;
  height: 60px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background: url('https://law-smartapp.cdn.bcebos.com/goods/chat-right-suspend.png') no-repeat;
  background-size: 100% 100%;
  position: absolute;
  right: -127px;
  top: -188px;
  opacity: 0.6;
  transition: all 0.3s linear;
}
.speed-call-lawyer .speed-content {
  width: 114px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}
.speed-call-lawyer .speed-content .top {
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 16px;
  color: #1f1f1f;
  line-height: 16px;
  font-weight: 500;
}
.speed-call-lawyer .speed-content .bottom {
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 12px;
  color: #1f1f1f;
  line-height: 12px;
  font-weight: 400;
  margin-top: 5px;
}
.speed-call-lawyer .space-close {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-right: -7px;
}
.speed-call-lawyer .space-close .close-speed {
  font-size: 16px;
}
.speed-call-lawyer-light {
  right: 0;
  opacity: 1;
}
.inner-ph {
  min-height: 20px;
  max-height: 57px;
  line-height: 19px;
  margin: 0 30px 0 15px;
  box-sizing: border-box;
  font-size: 16px;
  visibility: hidden;
  overflow: hidden;
}
.textarea-min-height {
  min-height: 28px;
  line-height: 19px;
}
.im-input-control-mask {
  position: fixed;
  top: -100px;
  bottom: -100px;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  box-sizing: border-box;
}
.im-input-control {
  position: absolute;
  bottom: 100px;
  left: 0;
  width: 100%;
  margin: 0;
  box-sizing: border-box;
  padding: 0.1rem 0.17rem 0.15rem;
  background-color: #fff;
  color: #555;
  font: 14px/24px;
  word-break: break-word;
  word-wrap: break-word;
  border: 0 none;
}
.im-input-control-btns {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.im-input-textarea-wrapper-h5 {
  flex: 1;
  align-items: center;
  background: #f5f5f5;
  border-radius: 0.19rem;
  overflow: hidden;
  position: relative;
  border: 1px solid #eee;
  box-sizing: border-box;
}
.im-input-textarea-wrapper-h5 .clear-input {
  width: 0.16rem;
  height: 0.16rem;
  position: absolute;
  right: 0.1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #b8b8b8;
  font-size: 0.16rem;
  line-height: 0.16rem;
  padding: 0.05rem;
  z-index: 20;
}
.im-input-control-textarea {
  margin-top: 0.15rem;
  padding: 0.12rem 0.18rem;
  border: 1px solid #e1e1e1;
  font-size: 15px;
  width: 100%;
  height: 60px;
  line-height: 20px;
  box-sizing: border-box;
  resize: none;
  word-wrap: break-word;
}
.im-input-control-textarea-h5 {
  display: inline-block;
  overflow: scroll;
  width: calc(100% - 45px);
  height: calc(100% - 15px);
  vertical-align: middle;
  word-break: break-word;
  word-wrap: break-word;
  outline: 0;
  background-color: #f6f6f6;
  -webkit-appearance: none;
  resize: none;
  border: none;
  position: absolute;
  line-height: 20px;
  margin: 8px 20px 3px 15px;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  box-sizing: border-box;
}
.im-input-control-textarea-h5::-webkit-scrollbar {
  width: 0;
  height: 0;
  color: transparent;
  display: none;
}
.inner-ph {
  min-height: 20px;
  max-height: 60px;
  line-height: 20px;
  margin: 7.5px 30px 7.5px 15px;
  box-sizing: border-box;
  font-size: 16px;
  visibility: hidden;
}

</style>
